import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import Flex from '@ms/yammer-web-core-ui/dist/components/Flex';
import type { FC } from 'react';
import React from 'react';

import { toggleLeftNavCollapsed, useIsLeftNavCollapsed } from '../store';

import CollapseIconButton from './CollapseIconButton';
import { collapsedRailSlotSize } from './collapsedRail';

const toggleButtonHeight = 32;

const NavCollapseToggle: FC = () => {
  'use memo';

  const t = useTranslations(NavigationStrings);
  const isCollapsed = useIsLeftNavCollapsed();

  const ariaLabel = isCollapsed ? t.appNavigationExpandButtonAriaLabel() : t.appNavigationCollapseButtonAriaLabel();

  const toggle = (
    <CollapseIconButton
      ariaLabel={ariaLabel}
      ariaExpanded={!isCollapsed}
      height={toggleButtonHeight}
      onClick={toggleLeftNavCollapsed}
    />
  );

  return isCollapsed ? (
    <Flex
      shrink={0}
      justifyContent="center"
      alignItems="center"
      minHeight={collapsedRailSlotSize}
      minWidth={collapsedRailSlotSize}
    >
      {toggle}
    </Flex>
  ) : (
    toggle
  );
};

export default NavCollapseToggle;
